var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipelinesMatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4 23.5V3C29.4 2.77909 29.2209 2.6 29 2.6H15C14.7791 2.6 14.6 2.77909 14.6 3V23.9H29C29.2209 23.9 29.4 23.7209 29.4 23.5Z",
    stroke: "#2968C9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 29V8.5C1.6 8.27909 1.77909 8.1 2 8.1H16C16.2209 8.1 16.4 8.27909 16.4 8.5V29C16.4 29.2209 16.2209 29.4 16 29.4H2C1.77909 29.4 1.6 29.2209 1.6 29Z",
    fill: "none",
    stroke: "#2968C9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelinesMatch);
export default __webpack_public_path__ + "static/media/pipelines-match.1154a9e4906bad996cf63c15524063bd.svg";
export { ForwardRef as ReactComponent };